export default {
  "id": "6e6ce9ee0d82bf2229d56a25cb835d74",
  "tags": {},
  "filePath": "/home/runner/work/react-showroom/react-showroom/examples/subpath-example/src/components/button.tsx",
  "description": "`<Button />` component wraps a `<button />` element and spread all the props.",
  "displayName": "Button",
  "methods": [],
  "props": {
    "variant": {
      "defaultValue": null,
      "description": "variant of the button",
      "name": "variant",
      "parent": {
        "fileName": "subpath-example/src/components/button.tsx",
        "name": "ButtonProps"
      },
      "declarations": [
        {
          "fileName": "subpath-example/src/components/button.tsx",
          "name": "ButtonProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "\"primary\" | \"outline\"",
        "value": [
          {
            "value": "\"primary\""
          },
          {
            "value": "\"outline\""
          }
        ]
      },
      "tags": {}
    },
    "size": {
      "defaultValue": null,
      "description": "",
      "name": "size",
      "parent": {
        "fileName": "subpath-example/src/components/button.tsx",
        "name": "ButtonProps"
      },
      "declarations": [
        {
          "fileName": "subpath-example/src/components/button.tsx",
          "name": "ButtonProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "\"small\" | \"large\"",
        "value": [
          {
            "value": "\"small\""
          },
          {
            "value": "\"large\""
          }
        ]
      },
      "tags": {}
    },
    "fullWidth": {
      "defaultValue": null,
      "description": "",
      "name": "fullWidth",
      "parent": {
        "fileName": "subpath-example/src/components/button.tsx",
        "name": "ButtonProps"
      },
      "declarations": [
        {
          "fileName": "subpath-example/src/components/button.tsx",
          "name": "ButtonProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "boolean",
        "value": [
          {
            "value": "false"
          },
          {
            "value": "true"
          }
        ]
      },
      "tags": {}
    },
    "leftIcon": {
      "defaultValue": null,
      "description": "",
      "name": "leftIcon",
      "parent": {
        "fileName": "subpath-example/src/components/button.tsx",
        "name": "ButtonProps"
      },
      "declarations": [
        {
          "fileName": "subpath-example/src/components/button.tsx",
          "name": "ButtonProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "ReactNode",
        "value": [
          {
            "value": "string"
          },
          {
            "value": "number"
          },
          {
            "value": "false"
          },
          {
            "value": "true"
          },
          {
            "value": "ReactElement<any, string | JSXElementConstructor<any>>",
            "description": "",
            "fullComment": "",
            "tags": {}
          },
          {
            "value": "ReactFragment",
            "description": "",
            "fullComment": "",
            "tags": {}
          },
          {
            "value": "ReactPortal",
            "description": "",
            "fullComment": "",
            "tags": {}
          }
        ]
      },
      "tags": {}
    }
  }
}